var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EntityTable',{attrs:{"entity-type":_vm.entityType,"headers":_vm.state.headers,"noNewItems":true},scopedSlots:_vm._u([{key:"fontGroups",fn:function(ref){
var item = ref.item;
return _vm._l((item.fontGroups),function(fontGroup){return _c('v-chip',{key:fontGroup.id,staticClass:"fontLabel",attrs:{"label":"","outlined":"","small":""}},[_vm._v(" "+_vm._s(fontGroup.name)+" ")])})}}])})}
var staticRenderFns = []

export { render, staticRenderFns }